import React from 'react';
import { FilterType } from '@/models/filter/FilterType';
import IconStar from '@/storybook/icons/IconStar';
import { SectionId } from './types/filterDraft.types';

export type SectionLabelKey =
  | 'global.filters.sectionHeaders.recommend'
  | 'global.filters.sectionHeaders.characteristics'
  | 'global.filters.sectionHeaders.hcoCharacteristics'
  | 'global.filters.sectionHeaders.hcoSegmentations'
  | 'global.filters.sectionHeaders.segmentations'
  | 'global.filters.sectionHeaders.scientificActivities';

export type SectionTooltipKey = 'global.filters.hcoCharacteristicsDisabledTooltip';

export type SectionConfig = {
  id: SectionId;
  labelKey: SectionLabelKey;
  filterKeys: (FilterType | FilterType[])[];
  icon?: React.ReactNode;
  testId?: string;
  disabled?: boolean;
  comingSoon?: boolean;
  tooltipKey?: SectionTooltipKey;
};

export const FILTER_SECTIONS: SectionConfig[] = [
  {
    id: 'recommendations',
    labelKey: 'global.filters.sectionHeaders.recommend',
    filterKeys: [
      FilterType.COUNTRY,
      FilterType.TERRITORY,
      FilterType.TA_INDICATIONS,
      FilterType.PRODUCTS,
      FilterType.CLASSIFICATION_LEVELS,
    ],
    icon: <IconStar />,
    testId: 'ces-filters-section-hcp-recommended-filters',
  },
  {
    id: 'characteristics',
    labelKey: 'global.filters.sectionHeaders.characteristics',
    filterKeys: [
      FilterType.COUNTRY,
      FilterType.TERRITORY,
      FilterType.STATE_PROVINCE,
      FilterType.TA,
      FilterType.SECONDARY_SPECIALTY,
      FilterType.OTHER_SPECIALTY,
      FilterType.HCP_PROFESSION,
      FilterType.HCP_TYPE_OF_PRACTICE,
      FilterType.SOURCE_SYSTEM,
      FilterType.AREA_OF_INTEREST,
      FilterType.HCP_X_TWITTER_ACCOUNT,
      FilterType.HCP_WITH_LINKED_IN_ACCOUNT,
      FilterType.HCP_WITH_BLUESKY_ACCOUNT,
    ],
    testId: 'ces-filters-section-hcp-characteristics',
  },
  {
    id: 'segmentations',
    labelKey: 'global.filters.sectionHeaders.segmentations',
    filterKeys: [
      FilterType.TA_INDICATIONS,
      FilterType.PRODUCTS,
      FilterType.CLASSIFICATION_LEVELS,
      FilterType.ADOPTION_RATING,
      FilterType.POTENTIAL_RATING,
      FilterType.TAE_LEVELS,
      FilterType.OPTHTALMOLOGY_PERSONAS,
      FilterType.VALUE_AND_MOTIVATION,
      FilterType.FAIR_MARKET_VALUE_RATING,
      FilterType.ROCHE_INTERACTION_LADDER,
      FilterType.PREFERRED_CHANNEL_RATING,
    ],
    testId: 'ces-filters-section-hcp-segmentations',
  },
  {
    id: 'scientificActivities',
    labelKey: 'global.filters.sectionHeaders.scientificActivities',
    filterKeys: [
      FilterType.TOPIC,
      FilterType.TRIAL_SPONSOR,
      FilterType.SCIENTIFIC_ORGANIZATION,
      [
        FilterType.CONGRESS,
        FilterType.PUBLICATION,
        FilterType.CLINICAL_TRIAL,
        FilterType.SOCIAL_MEDIA,
        FilterType.GUIDELINE,
      ],
    ],
    testId: 'ces-filters-section-hcp-scientific-activities',
  },
  {
    id: 'hcoCharacteristics',
    labelKey: 'global.filters.sectionHeaders.hcoCharacteristics',
    filterKeys: [
      FilterType.HCO_COUNTRY,
      FilterType.HCO_STATE_PROVINCE,
      FilterType.HCO_TYPE,
      FilterType.HCO_SPECIALTY,
      FilterType.HCO_PRIVATE_PUBLIC_STATUS,
      FilterType.HCO_SOURCE_SYSTEM,
      FilterType.HCO_ACCOUNT_PLANNING_IN_PROGRESS,
      FilterType.HCO_ACCOUNT_PLANNING_COMPLETED,
    ],
    testId: 'ces-filters-section-hco-characteristics',
  },
  {
    id: 'hcoSegmentations',
    labelKey: 'global.filters.sectionHeaders.hcoSegmentations',
    filterKeys: [],
    testId: 'ces-filters-section-hco-segmentations',
    disabled: true,
    comingSoon: true,
  },
];
